import googleDriveApiClient from './googleDriveApiClient';

type GoogleDriveFileUrlResponse = {
  webViewLink: string;
};

type GoogleDriveErrorResponse = {
  error: {
    code: number;
    message: string;
  };
};

export class CannotGetGoogleDriveFilePublicUrlError extends Error {}

const getGoogleDriveFilePublicUrl = async (
  googleDriveFileId: string,
): Promise<string> => {
  await googleDriveApiClient.post<unknown>(
    `/drive/v3/files/${googleDriveFileId}/permissions`,
    JSON.stringify({
      role: 'reader',
      type: 'anyone',
    }),
  );

  const webViewLinkResponse = await googleDriveApiClient.get<
    GoogleDriveFileUrlResponse | GoogleDriveErrorResponse
  >(`/drive/v3/files/${googleDriveFileId}?fields=webViewLink`);

  if ('error' in webViewLinkResponse) {
    throw new CannotGetGoogleDriveFilePublicUrlError(
      webViewLinkResponse.error.message,
    );
  }

  const googleDriveFilePublicUrl = webViewLinkResponse.webViewLink;

  return googleDriveFilePublicUrl;
};

export default getGoogleDriveFilePublicUrl;
